// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 添加全局平滑滚动，兜底原生点击行为的突变 */
html {
    scroll-behavior: smooth;
}

/* ================= 英雄区域 (Hero) - 科幻升级版 ================= */
.hero {
    height: 100vh;
    display: flex;
    align-items: center;
    position: relative;
    overflow: hidden;
    background: #0a0a0b; /* 深色底色，突出科技感 */
    --mouse-x: 50%;
    --mouse-y: 50%;
}

@media (min-width: 992px) {
    .hero {
        height: calc(100vh / 0.9);
        min-height: calc(100vh / 0.9);
    }
}

/* 科技感背景层 */
.cyber-background {
    position: absolute;
    inset: 0;
    z-index: 1;
    overflow: hidden;
}

/* 3D 网格 */
.grid-overlay {
    position: absolute;
    width: 200%;
    height: 200%;
    top: -50%;
    left: -50%;
    background-image:
            linear-gradient(to right, rgba(217, 0, 27, 0.1) 1px, transparent 1px),
            linear-gradient(to bottom, rgba(217, 0, 27, 0.1) 1px, transparent 1px);
    background-size: 50px 50px;
    transform: perspective(500px) rotateX(60deg) scale(1.05);
    animation: grid-drift 16s linear infinite;
    opacity: 0.95;
}

/* 鼠标交互光晕 */
.interactive-glow {
    position: absolute;
    inset: 0;
    background: radial-gradient(
            circle at var(--mouse-x) var(--mouse-y),
            rgba(217, 0, 27, 0.22) 0%,
            rgba(217, 0, 27, 0.1) 18%,
            transparent 42%
    );
    z-index: 2;
    mix-blend-mode: screen;
}

/* 移动扫描线 */
.moving-lines {
    position: absolute;
    inset: 0;
    background:
        linear-gradient(to bottom,
        transparent 0%,
        rgba(255, 255, 255, 0.03) 46%,
        rgba(217, 0, 27, 0.16) 50%,
        rgba(255, 255, 255, 0.03) 54%,
        transparent 100%),
        repeating-linear-gradient(
            to bottom,
            transparent 0 18px,
            rgba(217, 0, 27, 0.06) 18px 20px
        );
    background-size: 100% 100%, 100% 100%;
    animation: scan 4.8s linear infinite;
    opacity: 0.52;
    z-index: 3;
}

.hero-energy,
.hero-vignette {
    position: absolute;
    pointer-events: none;
}

.hero-energy {
    width: 44vw;
    height: 44vw;
    min-width: 420px;
    min-height: 420px;
    border-radius: 50%;
    filter: blur(18px);
    opacity: 0.42;
    z-index: 2;
    mix-blend-mode: screen;
}

.hero-energy-right {
    right: -10%;
    bottom: -16%;
    background: radial-gradient(circle, rgba(217, 0, 27, 0.3) 0%, rgba(217, 0, 27, 0.12) 32%, transparent 70%);
    animation: heroFloatRight 10s ease-in-out infinite;
}

.hero-vignette {
    inset: 0;
    z-index: 4;
    background:
        radial-gradient(circle at 50% 42%, transparent 0%, rgba(10, 10, 11, 0.06) 48%, rgba(10, 10, 11, 0.38) 100%),
        linear-gradient(180deg, rgba(10, 10, 11, 0.24) 0%, transparent 22%, transparent 78%, rgba(10, 10, 11, 0.32) 100%);
}

@keyframes grid-drift {
    from { transform: perspective(500px) rotateX(60deg) scale(1.05) translateY(0); }
    to { transform: perspective(500px) rotateX(60deg) scale(1.05) translateY(50px); }
}

@keyframes scan {
    from { transform: translateY(-100%); }
    to { transform: translateY(100%); }
}

@keyframes heroFloatRight {
    0%, 100% {
        transform: translate3d(0, 0, 0) scale(1);
        opacity: 0.34;
    }
    50% {
        transform: translate3d(-6%, -5%, 0) scale(1.06);
        opacity: 0.5;
    }
}

/* 内容修饰 */
.hero-content {
    width: 90%;
    max-width: 1400px;
    margin: 0 auto 0 max(5%, 24px);
    z-index: 10;
    position: relative;
    color: #fff;
}

/* 核心布局：Logo与标题同行并垂直居中 */
.hero-title-wrapper {
    display: flex;
    align-items: center;
    gap: 30px; /* Logo和文字之间的距离 */
    margin-bottom: 40px; /* 给下方按钮留出空间 */
    font-family: inherit;
}

/* 动态计算Logo高度，使其刚好约等于两行文字的总高度 */
.hero-logo {
    width: auto;
    height: calc(clamp(2.5rem, 6vw, 4.5rem) * 2.1);
    object-fit: contain;
}

.hero-title {
    font-size: clamp(2.5rem, 6vw, 4.5rem);
    font-weight: 900;
    line-height: 1.05;
    letter-spacing: -2px;
    margin: 0; /* 移除默认外边距，由父容器统一控制 */
}

/* 霓虹发光文字效果 */
.glitch-text {
    color: var(--accent-red);
    position: relative;
    text-shadow: 0 0 15px rgba(217, 0, 27, 0.4);
}

html:lang(ja) .hero-title {
    font-weight: 700;
}

html:lang(ja) .s-card-title {
    font-weight: 700;
}

/* 现代流光按钮 */
.btn-modern {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 18px 45px;
    background: var(--accent-red);
    color: white;
    text-decoration: none;
    font-weight: 700;
    border-radius: 4px;
    overflow: hidden;
    transition: 0.3s;
}

.btn-modern:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 30px rgba(217, 0, 27, 0.4);
}

.btn-glow {
    position: absolute;
    top: 0; left: -100%;
    width: 100%; height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent);
    transition: 0.5s;
}

.btn-modern:hover .btn-glow {
    left: 100%;
}

.hero-title-wrapper {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(320px, 0.95fr);
    gap: 40px;
    align-items: stretch;
    margin-bottom: 0;
}

.hero-copy-block {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 24px;
    min-height: clamp(240px, 28vw, 360px);
}

.hero-logo-panel {
    display: flex;
    align-items: stretch;
    justify-content: center;
    min-height: clamp(240px, 28vw, 360px);
}

.hero-logo {
    width: 100%;
    height: 100%;
    max-width: 520px;
    max-height: 100%;
    object-fit: contain;
    object-position: center;
}

.hero-btns {
    display: flex;
    justify-content: flex-start;
    align-items: center;
}

/* 下滑指示器 */
.scroll-indicator {
    position: absolute;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;
}

.mouse {
    width: 24px;
    height: 40px;
    border: 2px solid rgba(255,255,255,0.3);
    border-radius: 20px;
    position: relative;
}

.mouse::before {
    content: '';
    position: absolute;
    width: 4px; height: 8px;
    background: var(--accent-red);
    left: 50%; transform: translateX(-50%);
    top: 8px;
    border-radius: 2px;
    animation: mouse-scroll 2s infinite;
}

@keyframes mouse-scroll {
    0% { opacity: 1; transform: translate(-50%, 0); }
    100% { opacity: 0; transform: translate(-50%, 15px); }
}

/* ================= 其他 Section 保持原样 ================= */
.home-page .section-container {
    padding: 100px 5%;
    max-width: 1400px;
    margin: 0 auto;
}

.home-page #services.section-container {
    padding-bottom: 52px;
}

.home-page #home-news.section-container {
    padding-top: 52px;
}

/* ================= About Us ================= */
.about-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 40px; }
.about-grid > .philosophy-box {
    grid-column: 1 / -1;
}
.philosophy-box {
    background: linear-gradient(180deg, rgba(255,255,255,0.98) 0%, #faf7f7 100%);
    border: 1px solid var(--border-color);
    padding: 30px;
    border-radius: 24px;
    transition: var(--transition-fast);
    box-shadow: var(--shadow-sm);
}
.philosophy-box:hover { box-shadow: var(--shadow-lg); border-color: transparent; transform: translateY(-5px); }

/* 修改：为配合新加入的说明文字调整间距 */
.phil-title { font-size: 1.8rem; font-weight: 700; color: var(--accent-red); margin-bottom: 5px; }

/* 新增：公司理念卡片中的灰色说明文字 */
.phil-subtext {
    font-size: 0.85rem;
    color: var(--text-light, #888);
    margin-bottom: 20px;
    line-height: 1.5;
}

.phil-subtext-last {
    margin-bottom: 24px;
}

/* 新增：公司理念卡片中的大号子标题 */
.phil-subtitle {
    font-size: 1.6rem;
    font-weight: 700;
    color: #444;
    margin-bottom: 5px;
}

.phil-principles {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 14px;
    font-size: 0.92rem;
    color: var(--text-light);
}

.phil-principles p {
    padding: 14px 16px;
    border: 1px solid var(--border-color);
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.82);
    line-height: 1.7;
}

.phil-principles strong {
    color: var(--text-main);
}

.phil-principle-wide {
    grid-column: span 2;
}

.mission-vision {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    align-items: stretch;
}

.mv-card {
    background: linear-gradient(180deg, rgba(255,255,255,0.98) 0%, #faf7f7 100%);
    padding: 24px 26px;
    border-radius: 24px;
    border: 1px solid var(--border-color);
    box-shadow: var(--shadow-sm);
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    min-height: 0;
    position: relative;
    overflow: hidden;
}

.mv-tag {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: fit-content;
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    color: var(--accent-red);
    text-transform: uppercase;
    margin-bottom: 18px;
}

.mv-card h3 {
    font-size: 1.28rem;
    line-height: 1.7;
    color: var(--text-main);
    max-width: 28ch;
}

.team-grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 20px 16px;
    margin-top: 28px;
}
.team-member {
    text-align: center;
    min-width: 0;
}
.home-team-section {
    margin-top: 56px;
    margin-bottom: 0;
    padding: 28px;
    border-radius: 28px;
    border: 1px solid var(--border-color);
    background:
        radial-gradient(circle at top left, rgba(217, 0, 27, 0.06), transparent 28%),
        linear-gradient(180deg, rgba(255,255,255,0.98) 0%, #faf7f7 100%);
    box-shadow: var(--shadow-sm);
}
.home-team-header {
    margin-bottom: 0;
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: flex-start;
    gap: 18px;
}
.home-team-header h3 {
    font-size: 1.35rem;
    margin-top: 0;
}

.home-team-cta {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 8px 14px;
    border-radius: 999px;
    background: #fff3f4;
    border: 1px solid rgba(217, 0, 27, 0.12);
    color: var(--accent-red);
    font-size: 0.82rem;
    font-weight: 700;
    line-height: 1;
}

.team-avatar {
    width: min(100%, 128px); aspect-ratio: 1/1; border-radius: 32px; margin: 0 auto 12px;
    transition: var(--transition-fast); overflow: hidden; display: flex;
    align-items: center; justify-content: center; border: 1px solid rgba(217, 0, 27, 0.12);
    box-sizing: border-box;
    background:
        radial-gradient(circle at 30% 25%, rgba(255, 255, 255, 0.96), transparent 42%),
        linear-gradient(145deg, #ffffff 0%, #f6f7fb 100%);
    box-shadow: 0 14px 26px rgba(15, 23, 42, 0.08);
}
.team-avatar img { width: 100%; height: 100%; object-fit: cover; transition: transform 0.3s ease; }
.team-member:hover .team-avatar { box-shadow: 0 18px 34px rgba(217, 0, 27, 0.12); transform: translateY(-5px); border-color: var(--accent-red); }
.team-member:hover .team-avatar img { transform: scale(1.1); }
.team-name {
    font-size: 0.88rem;
    font-weight: 700;
    line-height: 1.4;
    word-break: break-word;
}
.home-team-header:hover .home-team-cta { background: var(--accent-red); color: #ffffff; }

/* ================= Services ================= */
.service-tags { display: flex; gap: 15px; margin-bottom: 28px; flex-wrap: wrap; }
.tag { border: 1px solid var(--accent-red); color: var(--accent-red); padding: 5px 15px; border-radius: 20px; font-size: 0.85rem; background: #fff; transition: 0.3s; }
.tag:hover { background: var(--accent-red); color: #fff; }
.service-intro-panel,
.why-card {
    background: linear-gradient(180deg, rgba(255,255,255,0.98) 0%, #faf7f7 100%);
    border: 1px solid var(--border-color);
    border-radius: 24px;
    padding: 28px;
    box-shadow: var(--shadow-sm);
}
.service-intro-panel {
    margin-bottom: 32px;
}
.service-kicker,
.service-mini-label,
.why-card-index {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    color: var(--accent-red);
    text-transform: uppercase;
}
.service-panel-title {
    margin: 12px 0;
    font-size: 1.5rem;
}
.service-highlight-list {
    display: grid;
    gap: 12px;
}
.service-highlight-item {
    position: relative;
    padding-left: 18px;
    color: var(--text-main);
    line-height: 1.7;
}
.service-highlight-item::before,
.why-bullet::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0.7em;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: var(--accent-red);
    transform: translateY(-50%);
}
.service-layout {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: 24px;
    align-items: stretch;
}
.service-img-main {
    height: 350px;
    width: 100%;
    border-radius: 24px;
    border: 1px solid var(--border-color);
    box-shadow: var(--shadow-sm);
    overflow: hidden;
}
.service-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 24px;
    display: block;
}
.service-cards { display: flex; flex-direction: column; gap: 20px; height: 350px; }
.s-card {
    background: linear-gradient(180deg, rgba(255,255,255,0.98) 0%, #faf7f7 100%);
    padding: 30px;
    border-radius: 24px;
    border: 1px solid var(--border-color);
    position: relative;
    overflow: hidden;
    transition: var(--transition-fast);
    cursor: pointer;
    flex: 1 1 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-shadow: var(--shadow-sm);
}
.s-card::before { content: ''; position: absolute; top: 0; left: 0; width: 4px; height: 100%; background: var(--accent-red); transform: scaleY(0); transition: 0.3s; transform-origin: top; }
.s-card:hover::before { transform: scaleY(1); }
.s-card:hover { box-shadow: var(--shadow-lg); transform: translateX(5px); }
.s-card-title { font-size: 1.5rem; font-weight: 800; color: var(--accent-red); margin-bottom: 10px; }
.why-choose-us {
    margin-top: 36px;
}
.why-header {
    margin-bottom: 24px;
}
.why-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
}
.why-card {
    position: relative;
    overflow: hidden;
}
.why-card-index {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: rgba(217, 0, 27, 0.08);
    margin-bottom: 16px;
}
.why-card h4 {
    font-size: 1.08rem;
    margin-bottom: 0;
    line-height: 1.6;
}
.why-bullets {
    display: grid;
    margin-top: 16px;
    gap: 10px;
}
.why-bullet {
    position: relative;
    padding-left: 18px;
    line-height: 1.7;
    color: var(--text-main);
}

/* ================= AI Solutions ================= */
.solution-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 40px; align-items: center; }

/* 修改：AI HR卡片改为 flex 布局支持图文左右排版 */
.ai-hr-card {
    background: var(--accent-red);
    color: #fff;
    padding: 30px; /* 稍微调小点 padding 适应图文组合 */
    border-radius: 20px;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    gap: 30px;
}

/* 新增：左侧图片盒子 */
.ai-hr-img-box {
    width: 140px;
    height: 140px;
    flex-shrink: 0;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 12px;
    overflow: hidden;
    border: 2px solid rgba(255, 255, 255, 0.3);
}

.ai-hr-img-box img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: block;
}

/* 新增：右侧文字部分 */
.ai-hr-text {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.ai-hr-text h3 {
    margin-bottom: 5px;
}

.ai-hr-text p {
    margin: 0;
}

.solution-list { display: flex; flex-direction: column; }
.sl-item { display: flex; border-bottom: 1px solid var(--border-color); padding: 25px 0; transition: var(--transition-fast); cursor: pointer; }
.sl-num { font-size: 2.5rem; color: var(--accent-red); font-weight: 300; width: 80px; transition: 0.3s; }
.sl-item:hover { transform: translateX(10px); }
.sl-item:hover .sl-num { color: var(--accent-red-hover); font-weight: bold; }

.mission-vision-compact {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 20px;
}

.home-section-cta {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-top: 14px;
    padding: 9px 16px;
    border-radius: 999px;
    background: #fff3f4;
    border: 1px solid rgba(217, 0, 27, 0.12);
    color: var(--accent-red);
    font-size: 0.86rem;
    font-weight: 700;
    line-height: 1;
    transition: var(--transition-fast);
}

.home-section-cta:hover {
    background: var(--accent-red);
    color: #ffffff;
    transform: translateY(-1px);
}

/* ================= Home News ================= */
.home-news-showcase {
    display: grid;
    grid-template-columns: minmax(0, 1.35fr) minmax(320px, 0.85fr);
    gap: 24px;
    align-items: stretch;
}

.home-news-lead-card,
.home-news-side-card {
    text-decoration: none;
    color: inherit;
    background: linear-gradient(180deg, rgba(255,255,255,0.98) 0%, #faf7f7 100%);
    border: 1px solid var(--border-color);
    border-radius: 28px;
    box-shadow: var(--shadow-sm);
    transition: var(--transition-fast);
    overflow: hidden;
}

.home-news-lead-card:hover,
.home-news-side-card:hover {
    transform: translateY(-4px);
    box-shadow: var(--shadow-lg);
    border-color: rgba(217, 0, 27, 0.18);
}

.home-news-lead-card {
    display: grid;
    grid-template-columns: minmax(240px, 0.9fr) minmax(0, 1.1fr);
    min-height: 360px;
}

.home-news-lead-media {
    min-height: 100%;
    background: linear-gradient(135deg, #120e0f 0%, #291112 100%);
}

.home-news-lead-media img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.home-news-media-placeholder {
    width: 100%;
    height: 100%;
    min-height: 260px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 28px;
    color: rgba(255, 255, 255, 0.72);
    text-align: center;
    line-height: 1.6;
}

.home-news-lead-content,
.home-news-side-card {
    display: flex;
    flex-direction: column;
}

.home-news-lead-content {
    padding: 30px;
    justify-content: space-between;
    gap: 18px;
}

.home-news-side-list {
    display: grid;
    gap: 20px;
}

.home-news-side-card {
    padding: 24px;
    min-height: 170px;
    justify-content: space-between;
    gap: 14px;
}

.home-news-meta-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;
}

.home-news-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 7px 12px;
    border-radius: 999px;
    background: #fff1f3;
    color: var(--accent-red);
    font-size: 0.78rem;
    font-weight: 700;
    line-height: 1;
}

.home-news-date {
    color: var(--text-light);
    font-size: 0.84rem;
}

.home-news-lead-content h3,
.home-news-side-card h3 {
    font-size: 1.42rem;
    line-height: 1.35;
    margin: 0;
    color: var(--text-main);
}

.home-news-side-card h3 {
    font-size: 1.12rem;
}

.home-news-lead-content p,
.home-news-side-card p,
.home-news-empty {
    color: var(--text-light);
    line-height: 1.75;
    margin: 0;
}

.home-news-link {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    color: var(--accent-red);
    font-weight: 700;
}

.home-news-empty {
    padding: 28px 30px;
    border-radius: 24px;
    background: linear-gradient(180deg, rgba(255,255,255,0.98) 0%, #faf7f7 100%);
    border: 1px solid var(--border-color);
    box-shadow: var(--shadow-sm);
}

/* Reveal Animation */
.reveal { opacity: 0; transform: translateY(30px); transition: all 0.8s ease-out; }
.reveal.active { opacity: 1; transform: translateY(0); }
.delay-1 { transition-delay: 0.2s; }
.delay-2 { transition-delay: 0.4s; }
.delay-3 { transition-delay: 0.6s; }

/* 响应式调整 */
@media (max-width: 992px) {
    .about-grid, .service-layout, .solution-grid, .why-grid { grid-template-columns: 1fr; }
    .mission-vision { grid-template-columns: 1fr; }
    .team-grid { grid-template-columns: repeat(4, 1fr); }
    .mission-vision-compact { grid-template-columns: 1fr; }
    .home-news-showcase,
    .home-news-lead-card { grid-template-columns: 1fr; }
    .home-team-header { flex-direction: column; }
}
@media (max-width: 768px) {
    .hero-title { font-size: 2.8rem; }
    .hero-title-wrapper { gap: 15px; flex-direction: column; align-items: flex-start; } /* 窄屏将Logo放在标题正上方以防拥挤 */
    .hero-logo { height: 60px; } /* 移动端限制固定高度 */
    .service-intro-panel,
    .why-card,
    .s-card,
    .mv-card { padding: 22px; }
    .phil-principles { grid-template-columns: 1fr; }
    .phil-principle-wide { grid-column: span 1; }
    .mv-card h3 { font-size: 1.12rem; }
    .home-team-section {
        margin-top: 44px;
        margin-bottom: 0;
        padding: 22px 18px;
        border-radius: 22px;
    }
    .team-grid { gap: 16px 12px; }
    .team-avatar {
        width: min(100%, 104px);
        border-radius: 24px;
    }
    .team-name { font-size: 0.82rem; }

    /* 移动端下 AI HR 卡片适配，改成上下排列即可 */
    .ai-hr-card {
        flex-direction: column;
        text-align: center;
    }

    .home-news-lead-content,
    .home-news-side-card {
        padding: 22px;
    }

    .home-news-lead-content h3 {
        font-size: 1.24rem;
    }
}

@media (max-width: 640px) {
    .team-grid {
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 14px 10px;
        margin-top: 22px;
    }

    .home-team-header {
        margin-bottom: 0;
        gap: 12px;
    }

    .home-team-header h3 {
        font-size: 1.2rem;
    }

    .team-avatar {
        width: min(100%, 90px);
        margin-bottom: 8px;
        border-radius: 22px;
    }

    .team-name {
        font-size: 0.76rem;
        line-height: 1.3;
    }
}

@media (max-width: 420px) {
    .team-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .team-avatar {
        width: min(100%, 94px);
    }

    .home-team-section {
        padding: 20px 16px;
    }

    .home-page #services.section-container {
        padding-bottom: 40px;
    }

    .home-page #home-news.section-container {
        padding-top: 40px;
    }
}

@media (max-width: 768px) {
    .hero-title-wrapper {
        grid-template-columns: 1fr;
        gap: 20px;
    }

    .hero-copy-block,
    .hero-logo-panel {
        min-height: 0;
    }

    .hero-logo-panel {
        justify-content: flex-start;
    }

    .hero-logo {
        width: auto;
        max-width: 100%;
    }
}

.hero-title-wrapper {
    grid-template-columns: fit-content(360px) minmax(0, 1fr);
    grid-template-areas: "logo copy";
    gap: clamp(4px, 0.9vw, 10px);
}

.hero-copy-block {
    grid-area: copy;
    align-items: flex-start;
    text-align: left;
}

.hero-logo-panel {
    grid-area: logo;
    justify-content: flex-start;
    width: fit-content;
}

.hero-logo {
    width: auto;
    height: 100%;
    max-width: 320px;
    object-fit: contain;
    object-position: left center;
}

.hero-title {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.18em;
}

.hero-title-line {
    display: block;
}

.hero-title-line-primary {
    white-space: nowrap;
}

.hero-title-line-secondary {
    white-space: nowrap;
    font-size: 0.92em;
}

.hero-btns {
    margin-top: 4px;
}

@media (max-width: 1100px) {
    .hero-title-wrapper {
        grid-template-columns: fit-content(280px) minmax(0, 1fr);
        grid-template-areas: "logo copy";
        gap: 6px;
    }

    .hero-title-line-secondary {
        white-space: normal;
        text-wrap: balance;
    }

    .hero-logo {
        max-width: 260px;
    }
}

@media (max-width: 768px) {
    .hero-title-wrapper {
        grid-template-columns: 1fr;
        grid-template-areas: "copy";
        gap: 0;
    }

    .hero-title-line-primary,
    .hero-title-line-secondary {
        white-space: normal;
    }

    .hero-title-line-secondary {
        text-wrap: balance;
    }

    .hero-content {
        width: min(90%, 560px);
        margin: 0 auto;
    }

    .hero-copy-block {
        min-height: 0;
        gap: 18px;
    }

    .hero-logo-panel {
        display: none;
    }

    .hero-title {
        gap: 0.24em;
        letter-spacing: -1px;
    }

    .hero-title-line-primary {
        font-size: 1em;
    }

    .hero-title-line-secondary {
        font-size: 0.8em;
        line-height: 1.25;
        max-width: 16ch;
    }

    .hero-btns {
        margin-top: 2px;
    }
}

/* Hero Final Center Layout */
.hero-content {
    width: min(90%, 1100px);
    margin: 0 auto;
    display: flex;
    justify-content: center;
    text-align: center;
}

.hero-title-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: clamp(18px, 2vw, 26px);
    width: 100%;
    margin: 0;
}

.hero-logo-panel {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    min-height: 0;
    transform: translateY(-22px);
}

.hero-logo {
    width: min(32vw, 280px);
    height: auto;
    max-width: 280px;
    max-height: none;
    object-fit: contain;
    object-position: center;
}

.hero-copy-block {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: clamp(22px, 2.8vw, 32px);
    min-height: 0;
}

.hero-title {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.28em;
    margin: 0;
    text-align: center;
    letter-spacing: -0.04em;
}

.hero-title-line {
    display: block;
}

.hero-title-line-primary {
    font-size: clamp(3.2rem, 7vw, 5.8rem);
    line-height: 0.98;
    white-space: nowrap;
}

.hero-title-line-secondary {
    max-width: 20ch;
    font-size: clamp(1.4rem, 2.5vw, 2.2rem);
    line-height: 1.28;
    white-space: normal;
    text-wrap: balance;
}

.hero-btns {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-top: 0;
}

.btn-modern {
    min-width: 220px;
    padding: 18px 42px;
    font-size: 1rem;
    border-radius: 999px;
}

@media (max-width: 768px) {
    .hero-content {
        width: min(90%, 560px);
    }

    .hero-title-wrapper {
        gap: 16px;
    }

    .hero-logo-panel {
        transform: translateY(-12px);
    }

    .hero-logo {
        width: min(48vw, 210px);
    }

    .hero-title-line-primary {
        font-size: clamp(2.5rem, 10vw, 3.6rem);
    }

    .hero-title-line-secondary {
        max-width: 14ch;
        font-size: clamp(1.05rem, 4.3vw, 1.45rem);
    }

    .btn-modern {
        min-width: 200px;
        padding: 16px 34px;
        font-size: 0.96rem;
    }

    .hero-energy {
        min-width: 280px;
        min-height: 280px;
        opacity: 0.34;
    }

}
`, "",{"version":3,"sources":["webpack://./src/styles/home.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;IACI,uBAAuB;AAC3B;;AAEA,4DAA4D;AAC5D;IACI,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB,EAAE,eAAe;IACpC,cAAc;IACd,cAAc;AAClB;;AAEA;IACI;QACI,yBAAyB;QACzB,6BAA6B;IACjC;AACJ;;AAEA,WAAW;AACX;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,gBAAgB;AACpB;;AAEA,UAAU;AACV;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,UAAU;IACV;;kFAE8E;IAC9E,0BAA0B;IAC1B,wDAAwD;IACxD,yCAAyC;IACzC,aAAa;AACjB;;AAEA,WAAW;AACX;IACI,kBAAkB;IAClB,QAAQ;IACR;;;;;KAKC;IACD,UAAU;IACV,sBAAsB;AAC1B;;AAEA,UAAU;AACV;IACI,kBAAkB;IAClB,QAAQ;IACR;;;;;;;;;;;SAWK;IACL,qCAAqC;IACrC,oCAAoC;IACpC,aAAa;IACb,UAAU;AACd;;AAEA;;IAEI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0GAA0G;IAC1G,kDAAkD;AACtD;;AAEA;IACI,QAAQ;IACR,UAAU;IACV;;yHAEqH;AACzH;;AAEA;IACI,OAAO,sEAAsE,EAAE;IAC/E,KAAK,yEAAyE,EAAE;AACpF;;AAEA;IACI,OAAO,4BAA4B,EAAE;IACrC,KAAK,2BAA2B,EAAE;AACtC;;AAEA;IACI;QACI,wCAAwC;QACxC,aAAa;IACjB;IACA;QACI,+CAA+C;QAC/C,YAAY;IAChB;AACJ;;AAEA,SAAS;AACT;IACI,UAAU;IACV,iBAAiB;IACjB,8BAA8B;IAC9B,WAAW;IACX,kBAAkB;IAClB,WAAW;AACf;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS,EAAE,iBAAiB;IAC5B,mBAAmB,EAAE,cAAc;IACnC,oBAAoB;AACxB;;AAEA,+BAA+B;AAC/B;IACI,WAAW;IACX,8CAA8C;IAC9C,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,SAAS,EAAE,qBAAqB;AACpC;;AAEA,aAAa;AACb;IACI,wBAAwB;IACxB,kBAAkB;IAClB,2CAA2C;AAC/C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,WAAW;AACX;IACI,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,6BAA6B;IAC7B,YAAY;IACZ,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,kBAAkB;IAClB,MAAM,EAAE,WAAW;IACnB,WAAW,EAAE,YAAY;IACzB,mFAAmF;IACnF,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,SAAS;IACT,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,uBAAuB;IACvB,qCAAqC;AACzC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA,UAAU;AACV;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uCAAuC;IACvC,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU,EAAE,WAAW;IACvB,6BAA6B;IAC7B,SAAS,EAAE,2BAA2B;IACtC,QAAQ;IACR,kBAAkB;IAClB,mCAAmC;AACvC;;AAEA;IACI,KAAK,UAAU,EAAE,6BAA6B,EAAE;IAChD,OAAO,UAAU,EAAE,gCAAgC,EAAE;AACzD;;AAEA,wDAAwD;AACxD;IACI,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,iDAAiD;AACjD,cAAc,aAAa,EAAE,8BAA8B,EAAE,SAAS,EAAE;AACxE;IACI,mBAAmB;AACvB;AACA;IACI,4EAA4E;IAC5E,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,kCAAkC;IAClC,4BAA4B;AAChC;AACA,wBAAwB,4BAA4B,EAAE,yBAAyB,EAAE,2BAA2B,EAAE;;AAE9G,uBAAuB;AACvB,cAAc,iBAAiB,EAAE,gBAAgB,EAAE,wBAAwB,EAAE,kBAAkB,EAAE;;AAEjG,sBAAsB;AACtB;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,qBAAqB;AACrB;IACI,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,qCAAqC;IACrC,mBAAmB;IACnB,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,oBAAoB;AACxB;;AAEA;IACI,4EAA4E;IAC5E,kBAAkB;IAClB,mBAAmB;IACnB,qCAAqC;IACrC,4BAA4B;IAC5B,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,wBAAwB;IACxB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,qCAAqC;IACrC;;wEAEoE;IACpE,4BAA4B;AAChC;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,uBAAuB;IACvB,SAAS;AACb;AACA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,wCAAwC;IACxC,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,uBAAuB,EAAE,iBAAiB,EAAE,mBAAmB,EAAE,mBAAmB;IACpF,kCAAkC,EAAE,gBAAgB,EAAE,aAAa;IACnE,mBAAmB,EAAE,uBAAuB,EAAE,wCAAwC;IACtF,sBAAsB;IACtB;;yDAEqD;IACrD,8CAA8C;AAClD;AACA,mBAAmB,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE,+BAA+B,EAAE;AAClG,kCAAkC,8CAA8C,EAAE,2BAA2B,EAAE,+BAA+B,EAAE;AAChJ,sCAAsC,qBAAqB,EAAE;AAC7D;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;AAC1B;AACA,yCAAyC,6BAA6B,EAAE,cAAc,EAAE;;AAExF,iDAAiD;AACjD,gBAAgB,aAAa,EAAE,SAAS,EAAE,mBAAmB,EAAE,eAAe,EAAE;AAChF,OAAO,mCAAmC,EAAE,wBAAwB,EAAE,iBAAiB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AACtK,aAAa,6BAA6B,EAAE,WAAW,EAAE;AACzD;;IAEI,4EAA4E;IAC5E,qCAAqC;IACrC,mBAAmB;IACnB,aAAa;IACb,4BAA4B;AAChC;AACA;IACI,mBAAmB;AACvB;AACA;;;IAGI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,wBAAwB;IACxB,yBAAyB;AAC7B;AACA;IACI,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,SAAS;AACb;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;AACpB;AACA;;IAEI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,6BAA6B;IAC7B,2BAA2B;AAC/B;AACA;IACI,aAAa;IACb,oDAAoD;IACpD,SAAS;IACT,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,qCAAqC;IACrC,4BAA4B;IAC5B,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;AAClB;AACA,iBAAiB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE,aAAa,EAAE;AAClF;IACI,4EAA4E;IAC5E,aAAa;IACb,mBAAmB;IACnB,qCAAqC;IACrC,kBAAkB;IAClB,gBAAgB;IAChB,kCAAkC;IAClC,eAAe;IACf,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;AAChC;AACA,kBAAkB,WAAW,EAAE,kBAAkB,EAAE,MAAM,EAAE,OAAO,EAAE,UAAU,EAAE,YAAY,EAAE,6BAA6B,EAAE,oBAAoB,EAAE,gBAAgB,EAAE,qBAAqB,EAAE;AAC5L,wBAAwB,oBAAoB,EAAE;AAC9C,gBAAgB,4BAA4B,EAAE,0BAA0B,EAAE;AAC1E,gBAAgB,iBAAiB,EAAE,gBAAgB,EAAE,wBAAwB,EAAE,mBAAmB,EAAE;AACpG;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;AACA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kCAAkC;IAClC,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,SAAS;AACb;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA,qDAAqD;AACrD,iBAAiB,aAAa,EAAE,8BAA8B,EAAE,SAAS,EAAE,mBAAmB,EAAE;;AAEhG,iCAAiC;AACjC;IACI,6BAA6B;IAC7B,WAAW;IACX,aAAa,EAAE,yBAAyB;IACxC,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA,cAAc;AACd;IACI,YAAY;IACZ,aAAa;IACb,cAAc;IACd,oCAAoC;IACpC,mBAAmB;IACnB,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,uBAAuB;IACvB,cAAc;AAClB;;AAEA,cAAc;AACd;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,SAAS;AACb;;AAEA,iBAAiB,aAAa,EAAE,sBAAsB,EAAE;AACxD,WAAW,aAAa,EAAE,4CAA4C,EAAE,eAAe,EAAE,kCAAkC,EAAE,eAAe,EAAE;AAC9I,UAAU,iBAAiB,EAAE,wBAAwB,EAAE,gBAAgB,EAAE,WAAW,EAAE,gBAAgB,EAAE;AACxG,iBAAiB,2BAA2B,EAAE;AAC9C,yBAAyB,8BAA8B,EAAE,iBAAiB,EAAE;;AAE5E;IACI,gDAAgD;IAChD,SAAS;AACb;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,wCAAwC;IACxC,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,kCAAkC;AACtC;;AAEA;IACI,6BAA6B;IAC7B,cAAc;IACd,2BAA2B;AAC/B;;AAEA,kDAAkD;AAClD;IACI,aAAa;IACb,8DAA8D;IAC9D,SAAS;IACT,oBAAoB;AACxB;;AAEA;;IAEI,qBAAqB;IACrB,cAAc;IACd,4EAA4E;IAC5E,qCAAqC;IACrC,mBAAmB;IACnB,4BAA4B;IAC5B,kCAAkC;IAClC,gBAAgB;AACpB;;AAEA;;IAEI,2BAA2B;IAC3B,4BAA4B;IAC5B,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,6DAA6D;AACjE;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;IAClB,iBAAiB;IACjB,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;;IAGI,wBAAwB;IACxB,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,4EAA4E;IAC5E,qCAAqC;IACrC,4BAA4B;AAChC;;AAEA,qBAAqB;AACrB,UAAU,UAAU,EAAE,2BAA2B,EAAE,6BAA6B,EAAE;AAClF,iBAAiB,UAAU,EAAE,wBAAwB,EAAE;AACvD,WAAW,sBAAsB,EAAE;AACnC,WAAW,sBAAsB,EAAE;AACnC,WAAW,sBAAsB,EAAE;;AAEnC,UAAU;AACV;IACI,0DAA0D,0BAA0B,EAAE;IACtF,kBAAkB,0BAA0B,EAAE;IAC9C,aAAa,qCAAqC,EAAE;IACpD,0BAA0B,0BAA0B,EAAE;IACtD;2BACuB,0BAA0B,EAAE;IACnD,oBAAoB,sBAAsB,EAAE;AAChD;AACA;IACI,cAAc,iBAAiB,EAAE;IACjC,sBAAsB,SAAS,EAAE,sBAAsB,EAAE,uBAAuB,EAAE,EAAE,uBAAuB;IAC3G,aAAa,YAAY,EAAE,EAAE,cAAc;IAC3C;;;eAGW,aAAa,EAAE;IAC1B,mBAAmB,0BAA0B,EAAE;IAC/C,uBAAuB,mBAAmB,EAAE;IAC5C,cAAc,kBAAkB,EAAE;IAClC;QACI,gBAAgB;QAChB,gBAAgB;QAChB,kBAAkB;QAClB,mBAAmB;IACvB;IACA,aAAa,cAAc,EAAE;IAC7B;QACI,uBAAuB;QACvB,mBAAmB;IACvB;IACA,aAAa,kBAAkB,EAAE;;IAEjC,6BAA6B;IAC7B;QACI,sBAAsB;QACtB,kBAAkB;IACtB;;IAEA;;QAEI,aAAa;IACjB;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,gDAAgD;QAChD,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,SAAS;IACb;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;QACtB,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gDAAgD;IACpD;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA;;QAEI,aAAa;IACjB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;AACJ;;AAEA;IACI,wDAAwD;IACxD,gCAAgC;IAChC,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,wDAAwD;QACxD,gCAAgC;QAChC,QAAQ;IACZ;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,0BAA0B;QAC1B,2BAA2B;QAC3B,MAAM;IACV;;IAEA;;QAEI,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;QACtB,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,SAAS;IACb;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,oBAAoB;IACxB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA,6BAA6B;AAC7B;IACI,uBAAuB;IACvB,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;IAC3B,WAAW;IACX,SAAS;AACb;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,4BAA4B;AAChC;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;IAC7B,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qCAAqC;IACrC,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,uCAAuC;IACvC,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,sCAAsC;IAC1C;;IAEA;QACI,eAAe;QACf,yCAAyC;IAC7C;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,aAAa;IACjB;;AAEJ","sourcesContent":["/* 添加全局平滑滚动，兜底原生点击行为的突变 */\r\nhtml {\r\n    scroll-behavior: smooth;\r\n}\r\n\r\n/* ================= 英雄区域 (Hero) - 科幻升级版 ================= */\r\n.hero {\r\n    height: 100vh;\r\n    display: flex;\r\n    align-items: center;\r\n    position: relative;\r\n    overflow: hidden;\r\n    background: #0a0a0b; /* 深色底色，突出科技感 */\r\n    --mouse-x: 50%;\r\n    --mouse-y: 50%;\r\n}\r\n\r\n@media (min-width: 992px) {\r\n    .hero {\r\n        height: calc(100vh / 0.9);\r\n        min-height: calc(100vh / 0.9);\r\n    }\r\n}\r\n\r\n/* 科技感背景层 */\r\n.cyber-background {\r\n    position: absolute;\r\n    inset: 0;\r\n    z-index: 1;\r\n    overflow: hidden;\r\n}\r\n\r\n/* 3D 网格 */\r\n.grid-overlay {\r\n    position: absolute;\r\n    width: 200%;\r\n    height: 200%;\r\n    top: -50%;\r\n    left: -50%;\r\n    background-image:\r\n            linear-gradient(to right, rgba(217, 0, 27, 0.1) 1px, transparent 1px),\r\n            linear-gradient(to bottom, rgba(217, 0, 27, 0.1) 1px, transparent 1px);\r\n    background-size: 50px 50px;\r\n    transform: perspective(500px) rotateX(60deg) scale(1.05);\r\n    animation: grid-drift 16s linear infinite;\r\n    opacity: 0.95;\r\n}\r\n\r\n/* 鼠标交互光晕 */\r\n.interactive-glow {\r\n    position: absolute;\r\n    inset: 0;\r\n    background: radial-gradient(\r\n            circle at var(--mouse-x) var(--mouse-y),\r\n            rgba(217, 0, 27, 0.22) 0%,\r\n            rgba(217, 0, 27, 0.1) 18%,\r\n            transparent 42%\r\n    );\r\n    z-index: 2;\r\n    mix-blend-mode: screen;\r\n}\r\n\r\n/* 移动扫描线 */\r\n.moving-lines {\r\n    position: absolute;\r\n    inset: 0;\r\n    background:\r\n        linear-gradient(to bottom,\r\n        transparent 0%,\r\n        rgba(255, 255, 255, 0.03) 46%,\r\n        rgba(217, 0, 27, 0.16) 50%,\r\n        rgba(255, 255, 255, 0.03) 54%,\r\n        transparent 100%),\r\n        repeating-linear-gradient(\r\n            to bottom,\r\n            transparent 0 18px,\r\n            rgba(217, 0, 27, 0.06) 18px 20px\r\n        );\r\n    background-size: 100% 100%, 100% 100%;\r\n    animation: scan 4.8s linear infinite;\r\n    opacity: 0.52;\r\n    z-index: 3;\r\n}\r\n\r\n.hero-energy,\r\n.hero-vignette {\r\n    position: absolute;\r\n    pointer-events: none;\r\n}\r\n\r\n.hero-energy {\r\n    width: 44vw;\r\n    height: 44vw;\r\n    min-width: 420px;\r\n    min-height: 420px;\r\n    border-radius: 50%;\r\n    filter: blur(18px);\r\n    opacity: 0.42;\r\n    z-index: 2;\r\n    mix-blend-mode: screen;\r\n}\r\n\r\n.hero-energy-right {\r\n    right: -10%;\r\n    bottom: -16%;\r\n    background: radial-gradient(circle, rgba(217, 0, 27, 0.3) 0%, rgba(217, 0, 27, 0.12) 32%, transparent 70%);\r\n    animation: heroFloatRight 10s ease-in-out infinite;\r\n}\r\n\r\n.hero-vignette {\r\n    inset: 0;\r\n    z-index: 4;\r\n    background:\r\n        radial-gradient(circle at 50% 42%, transparent 0%, rgba(10, 10, 11, 0.06) 48%, rgba(10, 10, 11, 0.38) 100%),\r\n        linear-gradient(180deg, rgba(10, 10, 11, 0.24) 0%, transparent 22%, transparent 78%, rgba(10, 10, 11, 0.32) 100%);\r\n}\r\n\r\n@keyframes grid-drift {\r\n    from { transform: perspective(500px) rotateX(60deg) scale(1.05) translateY(0); }\r\n    to { transform: perspective(500px) rotateX(60deg) scale(1.05) translateY(50px); }\r\n}\r\n\r\n@keyframes scan {\r\n    from { transform: translateY(-100%); }\r\n    to { transform: translateY(100%); }\r\n}\r\n\r\n@keyframes heroFloatRight {\r\n    0%, 100% {\r\n        transform: translate3d(0, 0, 0) scale(1);\r\n        opacity: 0.34;\r\n    }\r\n    50% {\r\n        transform: translate3d(-6%, -5%, 0) scale(1.06);\r\n        opacity: 0.5;\r\n    }\r\n}\r\n\r\n/* 内容修饰 */\r\n.hero-content {\r\n    width: 90%;\r\n    max-width: 1400px;\r\n    margin: 0 auto 0 max(5%, 24px);\r\n    z-index: 10;\r\n    position: relative;\r\n    color: #fff;\r\n}\r\n\r\n/* 核心布局：Logo与标题同行并垂直居中 */\r\n.hero-title-wrapper {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 30px; /* Logo和文字之间的距离 */\r\n    margin-bottom: 40px; /* 给下方按钮留出空间 */\r\n    font-family: inherit;\n}\r\n\r\n/* 动态计算Logo高度，使其刚好约等于两行文字的总高度 */\r\n.hero-logo {\r\n    width: auto;\r\n    height: calc(clamp(2.5rem, 6vw, 4.5rem) * 2.1);\r\n    object-fit: contain;\r\n}\r\n\r\n.hero-title {\r\n    font-size: clamp(2.5rem, 6vw, 4.5rem);\r\n    font-weight: 900;\r\n    line-height: 1.05;\r\n    letter-spacing: -2px;\r\n    margin: 0; /* 移除默认外边距，由父容器统一控制 */\r\n}\r\n\r\n/* 霓虹发光文字效果 */\r\n.glitch-text {\n    color: var(--accent-red);\n    position: relative;\r\n    text-shadow: 0 0 15px rgba(217, 0, 27, 0.4);\r\n}\n\nhtml:lang(ja) .hero-title {\n    font-weight: 700;\n}\n\nhtml:lang(ja) .s-card-title {\n    font-weight: 700;\n}\n\r\n/* 现代流光按钮 */\r\n.btn-modern {\r\n    position: relative;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 18px 45px;\r\n    background: var(--accent-red);\r\n    color: white;\r\n    text-decoration: none;\r\n    font-weight: 700;\r\n    border-radius: 4px;\r\n    overflow: hidden;\r\n    transition: 0.3s;\r\n}\r\n\r\n.btn-modern:hover {\r\n    transform: translateY(-3px);\r\n    box-shadow: 0 10px 30px rgba(217, 0, 27, 0.4);\r\n}\r\n\r\n.btn-glow {\r\n    position: absolute;\r\n    top: 0; left: -100%;\r\n    width: 100%; height: 100%;\r\n    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent);\r\n    transition: 0.5s;\r\n}\r\n\r\n.btn-modern:hover .btn-glow {\r\n    left: 100%;\r\n}\r\n\r\n.hero-title-wrapper {\r\n    display: grid;\r\n    grid-template-columns: minmax(0, 1fr) minmax(320px, 0.95fr);\r\n    gap: 40px;\r\n    align-items: stretch;\r\n    margin-bottom: 0;\r\n}\r\n\r\n.hero-copy-block {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: flex-start;\r\n    gap: 24px;\r\n    min-height: clamp(240px, 28vw, 360px);\r\n}\r\n\r\n.hero-logo-panel {\r\n    display: flex;\r\n    align-items: stretch;\r\n    justify-content: center;\r\n    min-height: clamp(240px, 28vw, 360px);\r\n}\r\n\r\n.hero-logo {\r\n    width: 100%;\r\n    height: 100%;\r\n    max-width: 520px;\r\n    max-height: 100%;\r\n    object-fit: contain;\r\n    object-position: center;\r\n}\r\n\r\n.hero-btns {\r\n    display: flex;\r\n    justify-content: flex-start;\r\n    align-items: center;\r\n}\r\n\r\n/* 下滑指示器 */\r\n.scroll-indicator {\r\n    position: absolute;\r\n    bottom: 30px;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    z-index: 10;\r\n}\r\n\r\n.mouse {\r\n    width: 24px;\r\n    height: 40px;\r\n    border: 2px solid rgba(255,255,255,0.3);\r\n    border-radius: 20px;\r\n    position: relative;\r\n}\r\n\r\n.mouse::before {\r\n    content: '';\r\n    position: absolute;\r\n    width: 4px; height: 8px;\r\n    background: var(--accent-red);\r\n    left: 50%; transform: translateX(-50%);\r\n    top: 8px;\r\n    border-radius: 2px;\r\n    animation: mouse-scroll 2s infinite;\r\n}\r\n\r\n@keyframes mouse-scroll {\r\n    0% { opacity: 1; transform: translate(-50%, 0); }\r\n    100% { opacity: 0; transform: translate(-50%, 15px); }\r\n}\r\n\r\n/* ================= 其他 Section 保持原样 ================= */\r\n.home-page .section-container {\n    padding: 100px 5%;\n    max-width: 1400px;\n    margin: 0 auto;\n}\n\n.home-page #services.section-container {\n    padding-bottom: 52px;\n}\n\n.home-page #home-news.section-container {\n    padding-top: 52px;\n}\n\r\n/* ================= About Us ================= */\r\n.about-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 40px; }\r\n.about-grid > .philosophy-box {\r\n    grid-column: 1 / -1;\r\n}\r\n.philosophy-box {\r\n    background: linear-gradient(180deg, rgba(255,255,255,0.98) 0%, #faf7f7 100%);\r\n    border: 1px solid var(--border-color);\r\n    padding: 30px;\r\n    border-radius: 24px;\r\n    transition: var(--transition-fast);\r\n    box-shadow: var(--shadow-sm);\r\n}\r\n.philosophy-box:hover { box-shadow: var(--shadow-lg); border-color: transparent; transform: translateY(-5px); }\r\n\r\n/* 修改：为配合新加入的说明文字调整间距 */\r\n.phil-title { font-size: 1.8rem; font-weight: 700; color: var(--accent-red); margin-bottom: 5px; }\r\n\r\n/* 新增：公司理念卡片中的灰色说明文字 */\r\n.phil-subtext {\r\n    font-size: 0.85rem;\r\n    color: var(--text-light, #888);\r\n    margin-bottom: 20px;\r\n    line-height: 1.5;\r\n}\r\n\r\n.phil-subtext-last {\r\n    margin-bottom: 24px;\r\n}\r\n\r\n/* 新增：公司理念卡片中的大号子标题 */\r\n.phil-subtitle {\r\n    font-size: 1.6rem;\r\n    font-weight: 700;\r\n    color: #444;\r\n    margin-bottom: 5px;\r\n}\r\n\r\n.phil-principles {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 14px;\r\n    font-size: 0.92rem;\r\n    color: var(--text-light);\r\n}\r\n\r\n.phil-principles p {\r\n    padding: 14px 16px;\r\n    border: 1px solid var(--border-color);\r\n    border-radius: 16px;\r\n    background: rgba(255, 255, 255, 0.82);\r\n    line-height: 1.7;\r\n}\r\n\r\n.phil-principles strong {\r\n    color: var(--text-main);\r\n}\r\n\r\n.phil-principle-wide {\r\n    grid-column: span 2;\r\n}\r\n\r\n.mission-vision {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 20px;\r\n    align-items: stretch;\r\n}\r\n\r\n.mv-card {\r\n    background: linear-gradient(180deg, rgba(255,255,255,0.98) 0%, #faf7f7 100%);\r\n    padding: 24px 26px;\r\n    border-radius: 24px;\r\n    border: 1px solid var(--border-color);\r\n    box-shadow: var(--shadow-sm);\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: flex-start;\r\n    min-height: 0;\r\n    position: relative;\r\n    overflow: hidden;\r\n}\r\n\r\n.mv-tag {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: fit-content;\r\n    font-size: 0.78rem;\r\n    font-weight: 700;\r\n    letter-spacing: 0.08em;\r\n    color: var(--accent-red);\r\n    text-transform: uppercase;\r\n    margin-bottom: 18px;\r\n}\r\n\r\n.mv-card h3 {\r\n    font-size: 1.28rem;\r\n    line-height: 1.7;\r\n    color: var(--text-main);\r\n    max-width: 28ch;\r\n}\r\n\r\n.team-grid {\n    display: grid;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    gap: 20px 16px;\n    margin-top: 28px;\n}\n.team-member {\n    text-align: center;\n    min-width: 0;\n}\n.home-team-section {\n    margin-top: 56px;\n    margin-bottom: 0;\n    padding: 28px;\n    border-radius: 28px;\n    border: 1px solid var(--border-color);\n    background:\n        radial-gradient(circle at top left, rgba(217, 0, 27, 0.06), transparent 28%),\n        linear-gradient(180deg, rgba(255,255,255,0.98) 0%, #faf7f7 100%);\n    box-shadow: var(--shadow-sm);\n}\n.home-team-header {\n    margin-bottom: 0;\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    align-items: flex-start;\n    gap: 18px;\n}\n.home-team-header h3 {\n    font-size: 1.35rem;\n    margin-top: 0;\n}\n\r\n.home-team-cta {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 8px 14px;\r\n    border-radius: 999px;\r\n    background: #fff3f4;\r\n    border: 1px solid rgba(217, 0, 27, 0.12);\r\n    color: var(--accent-red);\r\n    font-size: 0.82rem;\r\n    font-weight: 700;\r\n    line-height: 1;\r\n}\r\n\r\n.team-avatar {\n    width: min(100%, 128px); aspect-ratio: 1/1; border-radius: 32px; margin: 0 auto 12px;\n    transition: var(--transition-fast); overflow: hidden; display: flex;\n    align-items: center; justify-content: center; border: 1px solid rgba(217, 0, 27, 0.12);\n    box-sizing: border-box;\n    background:\n        radial-gradient(circle at 30% 25%, rgba(255, 255, 255, 0.96), transparent 42%),\n        linear-gradient(145deg, #ffffff 0%, #f6f7fb 100%);\n    box-shadow: 0 14px 26px rgba(15, 23, 42, 0.08);\n}\n.team-avatar img { width: 100%; height: 100%; object-fit: cover; transition: transform 0.3s ease; }\n.team-member:hover .team-avatar { box-shadow: 0 18px 34px rgba(217, 0, 27, 0.12); transform: translateY(-5px); border-color: var(--accent-red); }\n.team-member:hover .team-avatar img { transform: scale(1.1); }\n.team-name {\n    font-size: 0.88rem;\n    font-weight: 700;\n    line-height: 1.4;\n    word-break: break-word;\n}\n.home-team-header:hover .home-team-cta { background: var(--accent-red); color: #ffffff; }\n\r\n/* ================= Services ================= */\r\n.service-tags { display: flex; gap: 15px; margin-bottom: 28px; flex-wrap: wrap; }\r\n.tag { border: 1px solid var(--accent-red); color: var(--accent-red); padding: 5px 15px; border-radius: 20px; font-size: 0.85rem; background: #fff; transition: 0.3s; }\r\n.tag:hover { background: var(--accent-red); color: #fff; }\r\n.service-intro-panel,\r\n.why-card {\r\n    background: linear-gradient(180deg, rgba(255,255,255,0.98) 0%, #faf7f7 100%);\r\n    border: 1px solid var(--border-color);\r\n    border-radius: 24px;\r\n    padding: 28px;\r\n    box-shadow: var(--shadow-sm);\r\n}\r\n.service-intro-panel {\r\n    margin-bottom: 32px;\r\n}\r\n.service-kicker,\r\n.service-mini-label,\r\n.why-card-index {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-size: 0.78rem;\r\n    font-weight: 700;\r\n    letter-spacing: 0.08em;\r\n    color: var(--accent-red);\r\n    text-transform: uppercase;\r\n}\r\n.service-panel-title {\r\n    margin: 12px 0;\r\n    font-size: 1.5rem;\r\n}\r\n.service-highlight-list {\r\n    display: grid;\r\n    gap: 12px;\r\n}\r\n.service-highlight-item {\r\n    position: relative;\r\n    padding-left: 18px;\r\n    color: var(--text-main);\r\n    line-height: 1.7;\r\n}\r\n.service-highlight-item::before,\r\n.why-bullet::before {\r\n    content: '';\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0.7em;\r\n    width: 7px;\r\n    height: 7px;\r\n    border-radius: 50%;\r\n    background: var(--accent-red);\r\n    transform: translateY(-50%);\r\n}\r\n.service-layout {\r\n    display: grid;\r\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\r\n    gap: 24px;\r\n    align-items: stretch;\r\n}\r\n.service-img-main {\r\n    height: 350px;\r\n    width: 100%;\r\n    border-radius: 24px;\r\n    border: 1px solid var(--border-color);\r\n    box-shadow: var(--shadow-sm);\r\n    overflow: hidden;\r\n}\r\n.service-img {\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: cover;\r\n    border-radius: 24px;\r\n    display: block;\r\n}\r\n.service-cards { display: flex; flex-direction: column; gap: 20px; height: 350px; }\r\n.s-card {\r\n    background: linear-gradient(180deg, rgba(255,255,255,0.98) 0%, #faf7f7 100%);\r\n    padding: 30px;\r\n    border-radius: 24px;\r\n    border: 1px solid var(--border-color);\r\n    position: relative;\r\n    overflow: hidden;\r\n    transition: var(--transition-fast);\r\n    cursor: pointer;\r\n    flex: 1 1 0;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    box-shadow: var(--shadow-sm);\r\n}\r\n.s-card::before { content: ''; position: absolute; top: 0; left: 0; width: 4px; height: 100%; background: var(--accent-red); transform: scaleY(0); transition: 0.3s; transform-origin: top; }\r\n.s-card:hover::before { transform: scaleY(1); }\r\n.s-card:hover { box-shadow: var(--shadow-lg); transform: translateX(5px); }\r\n.s-card-title { font-size: 1.5rem; font-weight: 800; color: var(--accent-red); margin-bottom: 10px; }\r\n.why-choose-us {\r\n    margin-top: 36px;\r\n}\r\n.why-header {\r\n    margin-bottom: 24px;\r\n}\r\n.why-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(3, 1fr);\r\n    gap: 20px;\r\n}\r\n.why-card {\r\n    position: relative;\r\n    overflow: hidden;\r\n}\r\n.why-card-index {\r\n    width: 40px;\r\n    height: 40px;\r\n    border-radius: 50%;\r\n    background: rgba(217, 0, 27, 0.08);\r\n    margin-bottom: 16px;\r\n}\r\n.why-card h4 {\r\n    font-size: 1.08rem;\r\n    margin-bottom: 0;\r\n    line-height: 1.6;\r\n}\r\n.why-bullets {\r\n    display: grid;\r\n    margin-top: 16px;\r\n    gap: 10px;\r\n}\r\n.why-bullet {\r\n    position: relative;\r\n    padding-left: 18px;\r\n    line-height: 1.7;\r\n    color: var(--text-main);\r\n}\r\n\r\n/* ================= AI Solutions ================= */\r\n.solution-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 40px; align-items: center; }\r\n\r\n/* 修改：AI HR卡片改为 flex 布局支持图文左右排版 */\r\n.ai-hr-card {\r\n    background: var(--accent-red);\r\n    color: #fff;\r\n    padding: 30px; /* 稍微调小点 padding 适应图文组合 */\r\n    border-radius: 20px;\r\n    position: relative;\r\n    overflow: hidden;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 30px;\r\n}\r\n\r\n/* 新增：左侧图片盒子 */\r\n.ai-hr-img-box {\r\n    width: 140px;\r\n    height: 140px;\r\n    flex-shrink: 0;\r\n    background: rgba(255, 255, 255, 0.2);\r\n    border-radius: 12px;\r\n    overflow: hidden;\r\n    border: 2px solid rgba(255, 255, 255, 0.3);\r\n}\r\n\r\n.ai-hr-img-box img {\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: cover;\r\n    object-position: center;\r\n    display: block;\r\n}\r\n\r\n/* 新增：右侧文字部分 */\r\n.ai-hr-text {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n}\r\n\r\n.ai-hr-text h3 {\r\n    margin-bottom: 5px;\r\n}\r\n\r\n.ai-hr-text p {\r\n    margin: 0;\r\n}\r\n\r\n.solution-list { display: flex; flex-direction: column; }\r\n.sl-item { display: flex; border-bottom: 1px solid var(--border-color); padding: 25px 0; transition: var(--transition-fast); cursor: pointer; }\r\n.sl-num { font-size: 2.5rem; color: var(--accent-red); font-weight: 300; width: 80px; transition: 0.3s; }\r\n.sl-item:hover { transform: translateX(10px); }\r\n.sl-item:hover .sl-num { color: var(--accent-red-hover); font-weight: bold; }\r\n\r\n.mission-vision-compact {\r\n    grid-template-columns: repeat(2, minmax(0, 1fr));\r\n    gap: 20px;\r\n}\r\n\r\n.home-section-cta {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin-top: 14px;\r\n    padding: 9px 16px;\r\n    border-radius: 999px;\r\n    background: #fff3f4;\r\n    border: 1px solid rgba(217, 0, 27, 0.12);\r\n    color: var(--accent-red);\r\n    font-size: 0.86rem;\r\n    font-weight: 700;\r\n    line-height: 1;\r\n    transition: var(--transition-fast);\r\n}\r\n\r\n.home-section-cta:hover {\r\n    background: var(--accent-red);\r\n    color: #ffffff;\r\n    transform: translateY(-1px);\r\n}\r\n\r\n/* ================= Home News ================= */\r\n.home-news-showcase {\r\n    display: grid;\r\n    grid-template-columns: minmax(0, 1.35fr) minmax(320px, 0.85fr);\r\n    gap: 24px;\r\n    align-items: stretch;\r\n}\r\n\r\n.home-news-lead-card,\r\n.home-news-side-card {\r\n    text-decoration: none;\r\n    color: inherit;\r\n    background: linear-gradient(180deg, rgba(255,255,255,0.98) 0%, #faf7f7 100%);\r\n    border: 1px solid var(--border-color);\r\n    border-radius: 28px;\r\n    box-shadow: var(--shadow-sm);\r\n    transition: var(--transition-fast);\r\n    overflow: hidden;\r\n}\r\n\r\n.home-news-lead-card:hover,\r\n.home-news-side-card:hover {\r\n    transform: translateY(-4px);\r\n    box-shadow: var(--shadow-lg);\r\n    border-color: rgba(217, 0, 27, 0.18);\r\n}\r\n\r\n.home-news-lead-card {\r\n    display: grid;\r\n    grid-template-columns: minmax(240px, 0.9fr) minmax(0, 1.1fr);\r\n    min-height: 360px;\r\n}\r\n\r\n.home-news-lead-media {\r\n    min-height: 100%;\r\n    background: linear-gradient(135deg, #120e0f 0%, #291112 100%);\r\n}\r\n\r\n.home-news-lead-media img {\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: cover;\r\n    display: block;\r\n}\r\n\r\n.home-news-media-placeholder {\r\n    width: 100%;\r\n    height: 100%;\r\n    min-height: 260px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 28px;\r\n    color: rgba(255, 255, 255, 0.72);\r\n    text-align: center;\r\n    line-height: 1.6;\r\n}\r\n\r\n.home-news-lead-content,\r\n.home-news-side-card {\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.home-news-lead-content {\r\n    padding: 30px;\r\n    justify-content: space-between;\r\n    gap: 18px;\r\n}\r\n\r\n.home-news-side-list {\r\n    display: grid;\r\n    gap: 20px;\r\n}\r\n\r\n.home-news-side-card {\r\n    padding: 24px;\r\n    min-height: 170px;\r\n    justify-content: space-between;\r\n    gap: 14px;\r\n}\r\n\r\n.home-news-meta-row {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    gap: 12px;\r\n    flex-wrap: wrap;\r\n}\r\n\r\n.home-news-badge {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 7px 12px;\r\n    border-radius: 999px;\r\n    background: #fff1f3;\r\n    color: var(--accent-red);\r\n    font-size: 0.78rem;\r\n    font-weight: 700;\r\n    line-height: 1;\r\n}\r\n\r\n.home-news-date {\r\n    color: var(--text-light);\r\n    font-size: 0.84rem;\r\n}\r\n\r\n.home-news-lead-content h3,\r\n.home-news-side-card h3 {\r\n    font-size: 1.42rem;\r\n    line-height: 1.35;\r\n    margin: 0;\r\n    color: var(--text-main);\r\n}\r\n\r\n.home-news-side-card h3 {\r\n    font-size: 1.12rem;\r\n}\r\n\r\n.home-news-lead-content p,\r\n.home-news-side-card p,\r\n.home-news-empty {\r\n    color: var(--text-light);\r\n    line-height: 1.75;\r\n    margin: 0;\r\n}\r\n\r\n.home-news-link {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    color: var(--accent-red);\r\n    font-weight: 700;\r\n}\r\n\r\n.home-news-empty {\r\n    padding: 28px 30px;\r\n    border-radius: 24px;\r\n    background: linear-gradient(180deg, rgba(255,255,255,0.98) 0%, #faf7f7 100%);\r\n    border: 1px solid var(--border-color);\r\n    box-shadow: var(--shadow-sm);\r\n}\r\n\r\n/* Reveal Animation */\r\n.reveal { opacity: 0; transform: translateY(30px); transition: all 0.8s ease-out; }\r\n.reveal.active { opacity: 1; transform: translateY(0); }\r\n.delay-1 { transition-delay: 0.2s; }\r\n.delay-2 { transition-delay: 0.4s; }\r\n.delay-3 { transition-delay: 0.6s; }\r\n\r\n/* 响应式调整 */\r\n@media (max-width: 992px) {\n    .about-grid, .service-layout, .solution-grid, .why-grid { grid-template-columns: 1fr; }\n    .mission-vision { grid-template-columns: 1fr; }\n    .team-grid { grid-template-columns: repeat(4, 1fr); }\n    .mission-vision-compact { grid-template-columns: 1fr; }\n    .home-news-showcase,\n    .home-news-lead-card { grid-template-columns: 1fr; }\n    .home-team-header { flex-direction: column; }\n}\n@media (max-width: 768px) {\n    .hero-title { font-size: 2.8rem; }\r\n    .hero-title-wrapper { gap: 15px; flex-direction: column; align-items: flex-start; } /* 窄屏将Logo放在标题正上方以防拥挤 */\r\n    .hero-logo { height: 60px; } /* 移动端限制固定高度 */\r\n    .service-intro-panel,\r\n    .why-card,\r\n    .s-card,\r\n    .mv-card { padding: 22px; }\r\n    .phil-principles { grid-template-columns: 1fr; }\r\n    .phil-principle-wide { grid-column: span 1; }\r\n    .mv-card h3 { font-size: 1.12rem; }\n    .home-team-section {\n        margin-top: 44px;\n        margin-bottom: 0;\n        padding: 22px 18px;\n        border-radius: 22px;\n    }\n    .team-grid { gap: 16px 12px; }\n    .team-avatar {\n        width: min(100%, 104px);\n        border-radius: 24px;\n    }\n    .team-name { font-size: 0.82rem; }\n\r\n    /* 移动端下 AI HR 卡片适配，改成上下排列即可 */\r\n    .ai-hr-card {\r\n        flex-direction: column;\r\n        text-align: center;\r\n    }\r\n\r\n    .home-news-lead-content,\r\n    .home-news-side-card {\r\n        padding: 22px;\r\n    }\r\n\r\n    .home-news-lead-content h3 {\r\n        font-size: 1.24rem;\r\n    }\r\n}\n\n@media (max-width: 640px) {\n    .team-grid {\n        grid-template-columns: repeat(3, minmax(0, 1fr));\n        gap: 14px 10px;\n        margin-top: 22px;\n    }\n\n    .home-team-header {\n        margin-bottom: 0;\n        gap: 12px;\n    }\n\n    .home-team-header h3 {\n        font-size: 1.2rem;\n    }\n\n    .team-avatar {\n        width: min(100%, 90px);\n        margin-bottom: 8px;\n        border-radius: 22px;\n    }\n\n    .team-name {\n        font-size: 0.76rem;\n        line-height: 1.3;\n    }\n}\n\n@media (max-width: 420px) {\n    .team-grid {\n        grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n\n    .team-avatar {\n        width: min(100%, 94px);\n    }\n\n    .home-team-section {\n        padding: 20px 16px;\n    }\n\n    .home-page #services.section-container {\n        padding-bottom: 40px;\n    }\n\n    .home-page #home-news.section-container {\n        padding-top: 40px;\n    }\n}\n\r\n@media (max-width: 768px) {\r\n    .hero-title-wrapper {\r\n        grid-template-columns: 1fr;\r\n        gap: 20px;\r\n    }\r\n\r\n    .hero-copy-block,\r\n    .hero-logo-panel {\r\n        min-height: 0;\r\n    }\r\n\r\n    .hero-logo-panel {\r\n        justify-content: flex-start;\r\n    }\r\n\r\n    .hero-logo {\r\n        width: auto;\r\n        max-width: 100%;\r\n    }\r\n}\r\n\r\n.hero-title-wrapper {\r\n    grid-template-columns: fit-content(360px) minmax(0, 1fr);\r\n    grid-template-areas: \"logo copy\";\r\n    gap: clamp(4px, 0.9vw, 10px);\r\n}\r\n\r\n.hero-copy-block {\r\n    grid-area: copy;\r\n    align-items: flex-start;\r\n    text-align: left;\r\n}\r\n\r\n.hero-logo-panel {\r\n    grid-area: logo;\r\n    justify-content: flex-start;\r\n    width: fit-content;\r\n}\r\n\r\n.hero-logo {\r\n    width: auto;\r\n    height: 100%;\r\n    max-width: 320px;\r\n    object-fit: contain;\r\n    object-position: left center;\r\n}\r\n\r\n.hero-title {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 0.18em;\r\n}\r\n\r\n.hero-title-line {\r\n    display: block;\r\n}\r\n\r\n.hero-title-line-primary {\r\n    white-space: nowrap;\r\n}\r\n\r\n.hero-title-line-secondary {\r\n    white-space: nowrap;\r\n    font-size: 0.92em;\r\n}\r\n\r\n.hero-btns {\r\n    margin-top: 4px;\r\n}\r\n\r\n@media (max-width: 1100px) {\r\n    .hero-title-wrapper {\r\n        grid-template-columns: fit-content(280px) minmax(0, 1fr);\r\n        grid-template-areas: \"logo copy\";\r\n        gap: 6px;\r\n    }\r\n\r\n    .hero-title-line-secondary {\r\n        white-space: normal;\r\n        text-wrap: balance;\r\n    }\r\n\r\n    .hero-logo {\r\n        max-width: 260px;\r\n    }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .hero-title-wrapper {\r\n        grid-template-columns: 1fr;\r\n        grid-template-areas: \"copy\";\r\n        gap: 0;\r\n    }\r\n\r\n    .hero-title-line-primary,\r\n    .hero-title-line-secondary {\r\n        white-space: normal;\r\n    }\r\n\r\n    .hero-title-line-secondary {\r\n        text-wrap: balance;\r\n    }\r\n\r\n    .hero-content {\r\n        width: min(90%, 560px);\r\n        margin: 0 auto;\r\n    }\r\n\r\n    .hero-copy-block {\r\n        min-height: 0;\r\n        gap: 18px;\r\n    }\r\n\r\n    .hero-logo-panel {\r\n        display: none;\r\n    }\r\n\r\n    .hero-title {\r\n        gap: 0.24em;\r\n        letter-spacing: -1px;\r\n    }\r\n\r\n    .hero-title-line-primary {\r\n        font-size: 1em;\r\n    }\r\n\r\n    .hero-title-line-secondary {\r\n        font-size: 0.8em;\r\n        line-height: 1.25;\r\n        max-width: 16ch;\r\n    }\r\n\r\n    .hero-btns {\r\n        margin-top: 2px;\r\n    }\r\n}\r\n\r\n/* Hero Final Center Layout */\r\n.hero-content {\r\n    width: min(90%, 1100px);\r\n    margin: 0 auto;\r\n    display: flex;\r\n    justify-content: center;\r\n    text-align: center;\r\n}\r\n\r\n.hero-title-wrapper {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: clamp(18px, 2vw, 26px);\r\n    width: 100%;\r\n    margin: 0;\r\n}\r\n\r\n.hero-logo-panel {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    min-height: 0;\r\n    transform: translateY(-22px);\r\n}\r\n\r\n.hero-logo {\r\n    width: min(32vw, 280px);\r\n    height: auto;\r\n    max-width: 280px;\r\n    max-height: none;\r\n    object-fit: contain;\r\n    object-position: center;\r\n}\r\n\r\n.hero-copy-block {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: clamp(22px, 2.8vw, 32px);\r\n    min-height: 0;\r\n}\r\n\r\n.hero-title {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap: 0.28em;\r\n    margin: 0;\r\n    text-align: center;\r\n    letter-spacing: -0.04em;\r\n}\r\n\r\n.hero-title-line {\r\n    display: block;\r\n}\r\n\r\n.hero-title-line-primary {\r\n    font-size: clamp(3.2rem, 7vw, 5.8rem);\r\n    line-height: 0.98;\r\n    white-space: nowrap;\r\n}\r\n\r\n.hero-title-line-secondary {\r\n    max-width: 20ch;\r\n    font-size: clamp(1.4rem, 2.5vw, 2.2rem);\r\n    line-height: 1.28;\r\n    white-space: normal;\r\n    text-wrap: balance;\r\n}\r\n\r\n.hero-btns {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    margin-top: 0;\r\n}\r\n\r\n.btn-modern {\r\n    min-width: 220px;\r\n    padding: 18px 42px;\r\n    font-size: 1rem;\r\n    border-radius: 999px;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .hero-content {\r\n        width: min(90%, 560px);\r\n    }\r\n\r\n    .hero-title-wrapper {\r\n        gap: 16px;\r\n    }\r\n\r\n    .hero-logo-panel {\r\n        transform: translateY(-12px);\r\n    }\r\n\r\n    .hero-logo {\r\n        width: min(48vw, 210px);\r\n    }\r\n\r\n    .hero-title-line-primary {\r\n        font-size: clamp(2.5rem, 10vw, 3.6rem);\r\n    }\r\n\r\n    .hero-title-line-secondary {\r\n        max-width: 14ch;\r\n        font-size: clamp(1.05rem, 4.3vw, 1.45rem);\r\n    }\r\n\r\n    .btn-modern {\r\n        min-width: 200px;\r\n        padding: 16px 34px;\r\n        font-size: 0.96rem;\r\n    }\r\n\r\n    .hero-energy {\r\n        min-width: 280px;\r\n        min-height: 280px;\r\n        opacity: 0.34;\r\n    }\r\n\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
